import {
  ProvidersActionTypes,
  ProvidersConfigTypes,
} from 'containers/LandingPage/store/actions/providersConfig.actions';
import { IntegrationConfig } from 'models/integrationConfig';
import { LocationActionTypes, GetLocationTypes } from '../actions/getLocations.action';
import { Locations } from 'models/locations';
import { Organization } from 'models/organization';
import { APIKeyModel } from 'models/apikeys';
import { ProvIncomingData } from 'models/provIncomingData';
import { Team } from 'models/team';
import { TeamActionTypes, GetTeamTypes } from 'containers/LandingPage/store/actions/getTeam.action';
import { Worker } from 'models/worker';
import { WorkersActionTypes, GetWorkersTypes } from 'containers/LandingPage/store/actions/getWorkers.action';
import { BaseItem } from 'providers/airtable/components/SelectBase';
import { ProviderModel } from 'models/providers';
import { Position } from 'models/wheniwork';

export interface ProvidersConfigState {
  loading: boolean;
  data: IntegrationConfig[];
  error: string;
  isSaving: boolean;
  isDeleting: boolean;
  isEditing: boolean;
  errorSaving: string;
  teams: Team[];
  workers: Worker[];
  locations: Locations[];
  providers: ProviderModel[];
  APIkeyIDs: APIKeyModel[];
  provData: ProvIncomingData[];
  organization: Organization;
  authError: string;
  showSummaryState: boolean;
  stepId: number | null;
  airtableBases: BaseItem[];
  wiwPositions: Position[];
}

const initialState: ProvidersConfigState = {
  loading: false,
  data: [],
  error: '',
  isSaving: false,
  isDeleting: false,
  isEditing: false,
  errorSaving: '',
  teams: [],
  workers: [],
  locations: [],
  providers: [],
  APIkeyIDs: [],
  provData: [],
  organization: {},
  authError: '',
  showSummaryState:false,
  stepId: null,
  airtableBases: [],
  wiwPositions: [],
};

export default function reducer(
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state = initialState,
  action: ProvidersActionTypes | TeamActionTypes | WorkersActionTypes | LocationActionTypes,
): ProvidersConfigState {
  switch (action.type) {
    case ProvidersConfigTypes.SEARCH_PROVIDERS_CONFIG:
      return { ...state, loading: true };
    case ProvidersConfigTypes.SET_AUTH_ERROR:
      return { ...state, authError: action.payload.data };
    case ProvidersConfigTypes.REMOVE_AUTH_ERROR:
      return { ...state, authError: '' };
    case ProvidersConfigTypes.SHOW_SUMMARY:
      return { ...state, showSummaryState: true };
    case ProvidersConfigTypes.HIDE_SUMMARY:
      return { ...state, showSummaryState: false };
    case ProvidersConfigTypes.ENABLE_EDIT:
      return { ...state, isEditing: true };
    case ProvidersConfigTypes.DISABLE_EDIT:
      return { ...state, isEditing: false };
    case ProvidersConfigTypes.SET_STEP_ID:
      return { ...state, stepId: action.payload.data };
    case ProvidersConfigTypes.SEARCH_PROVIDERS:
      return { ...state, loading: true };
    case ProvidersConfigTypes.SEARCH_PROVIDERS_SUCCESS:
      return { ...state, providers: action.payload.data, loading: false };
    case ProvidersConfigTypes.SEARCH_PROVIDERS_ERROR:
      return { ...initialState, error: action.payload.error, loading: false };
    case ProvidersConfigTypes.SEARCH_PROVIDERS_CONFIG:
      return { ...state, loading: true };
    case ProvidersConfigTypes.SEARCH_PROVIDERS_CONFIG_SUCCESS:
      return { ...state, data: action.payload.data, loading: false };
    case ProvidersConfigTypes.SEARCH_PROVIDERS_CONFIG_ERROR:
      return { ...initialState, error: action.payload.error, loading: false };
    case ProvidersConfigTypes.SAVE_PROVIDERS_CONFIG:
      return { ...state, isSaving: true };
    case ProvidersConfigTypes.SAVE_PROVIDERS_CONFIG_SUCCESS:
      return { ...state, isSaving: false };
    case ProvidersConfigTypes.SAVE_PROVIDERS_CONFIG_ERROR:
      return {
        ...initialState,
        errorSaving: action.payload.error,
        isSaving: false,
      };
    case ProvidersConfigTypes.SEARCH_ORGANIZATION_API_KEY:
      return { ...state, loading: true };
    case ProvidersConfigTypes.SEARCH_ORGANIZATION_API_KEY_SUCCESS:
      return { ...state, APIkeyIDs: action.payload.data, loading: false };
    case ProvidersConfigTypes.SEARCH_ORGANIZATION_API_KEY_ERROR:
      return { ...state, error: action.payload.error, loading: false };
    case ProvidersConfigTypes.SEARCH_ORGANIZATION_TOKEN:
      return { ...state, loading: true };
    case ProvidersConfigTypes.SEARCH_ORGANIZATION_TOKEN_SUCCESS:
      return { ...state, organization: action.payload.data, loading: false };
    case ProvidersConfigTypes.SEARCH_ORGANIZATION_TOKEN_ERROR:
      return { ...initialState, error: action.payload.error, loading: false };

    case ProvidersConfigTypes.DELETE_PROVIDER_CONFIG:
      return { ...state, isDeleting: true };
    case ProvidersConfigTypes.DELETE_PROVIDER_CONFIG_SUCCESS:
      return { ...state, isDeleting: false };
    case ProvidersConfigTypes.DELETE_PROVIDER_CONFIG_ERROR:
      return { ...initialState, error: action.payload.error, loading: false };

    case ProvidersConfigTypes.SEARCH_AIRTABLE_BASES:
      return { ...state, loading: true };
    case ProvidersConfigTypes.SEARCH_AIRTABLE_BASES_SUCCESS:
      return { ...state, airtableBases: action.payload.data, loading: false };
    case ProvidersConfigTypes.SEARCH_AIRTABLE_BASES_ERROR:
      return { ...state, error: action.payload.error, loading: false };

    case GetTeamTypes.SEARCH_TEAMS_CONFIG:
      return { ...state, loading: true };
    case GetTeamTypes.SEARCH_TEAMS_CONFIG_SUCCESS:
      return { ...state, teams: action.payload.data, loading: false };
    case GetTeamTypes.SEARCH_TEAMS_CONFIG_ERROR:
      return { ...initialState, error: action.payload.error, loading: false };

    case GetWorkersTypes.SEARCH_WORKERS_CONFIG:
      return { ...state, loading: true };
    case GetWorkersTypes.SEARCH_WORKERS_CONFIG_SUCCESS:
      return { ...state, workers: action.payload.data, loading: false };
    case GetWorkersTypes.SEARCH_WORKERS_CONFIG_ERROR:
      return { ...initialState, error: action.payload.error, loading: false };

    case GetLocationTypes.SEARCH_LOCATIONS_CONFIG:
      return { ...state, loading: true };
    case GetLocationTypes.SEARCH_LOCATIONS_CONFIG_SUCCESS:
      return { ...state, locations: action.payload.data, loading: false };
    case GetLocationTypes.SEARCH_LOCATIONS_CONFIG_ERROR:
      return { ...initialState, error: action.payload.error, loading: false };

    case ProvidersConfigTypes.SEARCH_WIW_POSITIONS:
      return { ...state, loading: true };
    case ProvidersConfigTypes.SEARCH_WIW_POSITIONS_SUCCESS:
      return { ...state, wiwPositions: action.payload.data, loading: false };
    case ProvidersConfigTypes.SEARCH_WIW_POSITIONS_ERROR:
      return { ...state, error: action.payload.error, loading: false };

    case ProvidersConfigTypes.RESYNC_WIW_USERS:
      return { ...state, loading: true };
    case ProvidersConfigTypes.RESYNC_WIW_USERS_SUCCESS:
      return { ...state, loading: false };
    case ProvidersConfigTypes.RESYNC_WIW_USERS_ERROR:
      return { ...state, loading: false };

    default:
      return state;
  }
}
